import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAccountChildOverlay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			width: 32,
			height: 32,
			rx: 16,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			width: 32,
			height: 32,
			rx: 16,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16.3077 10.7692H14.9231V12.1538H16.3077V10.7692Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.3077 13.5385H14.9231V14.9231H16.3077V13.5385Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.3077 16.3077H14.9231V17.6923H16.3077V16.3077Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.3077 19.0769H14.9231V20.4615H16.3077V19.0769Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.0769 10.7692H17.6923V12.1538H19.0769V10.7692Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.0769 13.5385H17.6923V14.9231H19.0769V13.5385Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.0769 16.3077H17.6923V17.6923H19.0769V16.3077Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.0769 19.0769H17.6923V20.4615H19.0769V19.0769Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.3077 24.6154H21.8462V12.1538H23.2308V22.5385C23.2308 22.7221 23.3037 22.8982 23.4335 23.028C23.5634 23.1578 23.7395 23.2308 23.9231 23.2308C24.1067 23.2308 24.2828 23.1578 24.4126 23.028C24.5424 22.8982 24.6154 22.7221 24.6154 22.5385V11.4615C24.6154 11.2779 24.5424 11.1018 24.4126 10.972C24.2828 10.8422 24.1067 10.7692 23.9231 10.7692H21.8462V8.69231C21.8462 8.5087 21.7732 8.33261 21.6434 8.20277C21.5135 8.07294 21.3375 8 21.1538 8H12.8462C12.6625 8 12.4865 8.07294 12.3566 8.20277C12.2268 8.33261 12.1538 8.5087 12.1538 8.69231V10.7692H10.0769C9.89331 10.7692 9.71722 10.8422 9.58739 10.972C9.45755 11.1018 9.38462 11.2779 9.38462 11.4615V24.6154H8.69231C8.5087 24.6154 8.33261 24.6883 8.20277 24.8182C8.07294 24.948 8 25.1241 8 25.3077C8 25.4913 8.07294 25.6674 8.20277 25.7972C8.33261 25.9271 8.5087 26 8.69231 26H25.3077C25.4913 26 25.6674 25.9271 25.7972 25.7972C25.9271 25.6674 26 25.4913 26 25.3077C26 25.1241 25.9271 24.948 25.7972 24.8182C25.6674 24.6883 25.4913 24.6154 25.3077 24.6154ZM10.7692 12.1538H12.1538V22.5385C12.1538 22.7221 12.2268 22.8982 12.3566 23.028C12.4865 23.1578 12.6625 23.2308 12.8462 23.2308C13.0298 23.2308 13.2059 23.1578 13.3357 23.028C13.4655 22.8982 13.5385 22.7221 13.5385 22.5385V9.38462H20.4615V24.6154H19.0769V22.5385C19.0769 22.3549 19.004 22.1788 18.8742 22.0489C18.7443 21.9191 18.5682 21.8462 18.3846 21.8462H15.6154C15.4318 21.8462 15.2557 21.9191 15.1258 22.0489C14.996 22.1788 14.9231 22.3549 14.9231 22.5385V24.6154H10.7692V12.1538ZM17.6923 24.6154H16.3077V23.2308H17.6923V24.6154Z",
				fill: "currentColor"
			})
		] }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", { children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white",
			transform: "translate(8 8)"
		}) }) })
	]
});
export default SvgIconAccountChildOverlay;
